class CompareTable extends HTMLElement {
  constructor() {
    super();

    this.buttons = Array.from(this.querySelectorAll('[data-add-to-cart]'));
    this.errorMessage = this.querySelector('[data-error-message]');
    this.scroller = this.querySelector('.compare-table__scroller');
    this.progressBar = this.querySelector('[data-scroll-progress]');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.updateProgress = this.updateProgress.bind(this);
  }

  connectedCallback() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.addToCart.bind(this));
    });

    this.scroller?.addEventListener('scroll', this.updateProgress, { passive: true });
    window.addEventListener('resize', this.updateProgress);
    this.updateProgress();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.updateProgress);
    window.removeEventListener('resize', this.updateProgress);
  }

  updateProgress() {
    if (!this.scroller || !this.progressBar) return;

    const { clientWidth, scrollLeft, scrollWidth } = this.scroller;
    const maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 0) {
      this.progressBar.style.width = '100%';
      return;
    }

    const progressWidth = (scrollLeft / maxScroll) * 100;

    this.progressBar.style.width = `${progressWidth}%`;
  }

  getVariantId(button) {
    return Number(button.dataset.variantId);
  }

  hasAvailableVariant(button) {
    const variantId = this.getVariantId(button);

    return button.dataset.productAvailable === 'true' && Number.isFinite(variantId) && variantId > 0;
  }

  showError(message) {
    if (!this.errorMessage) return;

    this.errorMessage.textContent = message || '';
    this.errorMessage.toggleAttribute('hidden', !message);
  }

  setButtonLoading(button, isLoading) {
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading || !this.hasAvailableVariant(button);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
  }

  addToCart(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const variantId = this.getVariantId(button);

    if (!this.hasAvailableVariant(button) || button.disabled) return;

    this.showError('');
    this.setButtonLoading(button, true);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    const body = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    if (this.cart) {
      body.sections = this.cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      this.cart.setActiveElement(button);
    }

    config.body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'compare-table',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.showError(response.description || response.message);
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'compare-table',
          productVariantId: variantId,
          cartData: response,
        }).then(() => {
          this.cart.renderContents(response);
        });
      })
      .catch((error) => {
        console.error(error);
        this.showError(window.variantStrings?.cartError || 'Unable to add item to cart.');
      })
      .finally(() => {
        this.setButtonLoading(button, false);
      });
  }
}

if (!customElements.get('compare-table')) {
  customElements.define('compare-table', CompareTable);
}
